/**
 * Generado por nosotros, basandonos en componentes de ADF 5.0.0
 */

import { Component, inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SearchQueryBuilderService, SearchWidget, SearchWidgetSettings } from '@alfresco/adf-content-services';
import { KeyValue } from '@angular/common';
import { FormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SearchSelectComponent } from '../../../../search-select/search-select.component';
import { CustomDataColumn } from 'projects/alden-extension/src/lib/models/custom-viewer-config';

@Component({
    selector: 'smt-search-list-multi-property',
    templateUrl: './search-list-multi-property.component.html',
    styleUrls: ['./search-list-multi-property.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'smt-search-list-multi-property' }
})
export class SMTSearchListMultiPropertyComponent implements SearchWidget, OnInit, OnDestroy{

    id: string;
    settings?: SearchWidgetSettings;
    filter: CustomDataColumn;
    context?: SearchQueryBuilderService;
    options: KeyValue<string, string>[];
    operator: string = 'OR';
    startValue: string;
    displayValue$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    select: UntypedFormControl;
    form: UntypedFormGroup;
    private _formBuilder = inject(FormBuilder);
    filteredOptions: Observable<KeyValue<string, string>[]>;
    query: string;
    editable: boolean;

    private onDestroy$ = new Subject<boolean>();

    @ViewChild(SearchSelectComponent) searchSelectComponent!: SearchSelectComponent;
    
    get value() : KeyValue<string, string>[] {
        return this.form?.get('select')?.value;
    }

    constructor() {
        this.form =  this._formBuilder.group({
            "select": [[]]
        });   
        this.editable = true;
    }

    ngOnInit(): void {
        if (this.settings) {
            this.operator = (this.settings.operator) ? this.settings.operator: this.operator;

            this.setOptions();

            if(this.settings.allowUpdateOnChange !== undefined && this.settings.allowUpdateOnChange !== null) {
                this.editable = this.settings.allowUpdateOnChange;
            }
        }
    }
    
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    hasValidValue() {
        return this.value?.length > 0;
    }

    getCurrentValue() {
        return this.value?.map(element => element.key);
    }

    setOptions(){
        if (this.settings?.options && this.settings?.options.length > 0) {
            this.options = this.settings?.options;
        }
    }

    submitValues() {
       this.updateQuery();
       this.updateDisplayValue();
    }

    refreshFilter() {
        this.setOptions();

        //Comparar el value actual contra el que tenia, para ver si cambia el contador
        let newValues: KeyValue<string, string>[] = [];
        this.value.forEach(value => {
            newValues.push(this.options.find(element => element.key === value.key));
        });
       
        this.setValue(newValues);

        this.updateDisplayValue();
    }
    
    reset() {
        if(this.form.get('select').value)
            this.form.get('select').value.splice(0);
        this.updateQuery();
        this.updateDisplayValue();
    }

    updateDisplayValue(): void {
        if (this.form.invalid || this.value.length == 0) {
            this.displayValue$.next(null);
        } else {
            if(this.value.length == 1) {
                const maxLength = 25;
                const value = this.value[0].value;
                this.displayValue$.next({
                    value: value.substring(0, maxLength) + (value.length > maxLength ? '...' : ''),
                    tooltip: value
                });
            } else {
                this.displayValue$.next({
                    value: `${this.value.length} seleccionados`,
                    tooltip: this.value.map((v) => v.value).join(", ")
                });
            }   
        }
    }

    updateQuery() {
        if (this.id && this.context && this.field) {
            this.query = '';
            if(this.value && this.value.length > 0) {
                let filterQueryArray = []
                this.value.forEach(value => {
                    filterQueryArray.push(`@${this.field}:*${this.customData}=${value.key};`);
                });
                this.query = '('+filterQueryArray.join(` ${this.operator} `)+')';
                this.context.queryFragments[this.id] = this.query;
            }
        }
        if(this.context) {
            this.context.queryFragments[this.id] = this.query;
            this.context.update();
        }
    }

    //Custom SMT
    getCurrentQuery() {
        return this.query;
    }

    setValue(value: KeyValue<string, string>[] | string) {
        if(typeof value === 'string') {
            const option = this.options.find(opt => opt.key == value);
            value = [option] as KeyValue<string, string>[];
        }
        this.form.get('select').setValue(value);
    }

    getAppliedValue(): any {
        return this.value;
    }

    disable() {
        this.editable = false;
        this.form.get('select').disable();
    }

    enable() {
        this.editable = true;
        this.form.get('select').enable();
    }

    onWidgetOpened() {
        // Para que carge la lista inicial
        this.form.get('select').setValue('');
    }

    onWidgetClosed() {
        // Para que se limpie el input
        if(this.searchSelectComponent.selectInput)
            this.searchSelectComponent.selectInput.value = '';
        // Para cerrar el desplegable si se ha quedado abierto cuando no debe
        this.searchSelectComponent.autocompleteTrigger?.closePanel();
    }

    get customData(): any {
        return this.filter?.customData ? this.filter?.customData : null;
    }

    get field() : string {
        const settings = this.filter?.search?.settings;
        if(settings) {
            const field = settings?.field;
            if(field)
                return field;
        } else {
            const key = this.filter.key.split('properties.');
            if(key.length === 2)
                return key[1];
        }
        return "";
    }
 
}